/* unplugin-vue-components disabled */import { render } from "./QuestionnaireDialog.vue?vue&type=template&id=0b77de16&scoped=true"
import script from "./QuestionnaireDialog.vue?vue&type=script&lang=js"
export * from "./QuestionnaireDialog.vue?vue&type=script&lang=js"

import "./QuestionnaireDialog.vue?vue&type=style&index=0&id=0b77de16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b77de16"]])

export default __exports__